import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderKhmelnytskyi(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-khmelnytskyi/create-distribution-order-khmelnytskyi",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderKhmelnytskyi(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-khmelnytskyi/create-distribution-to-order-khmelnytskyi",
      params,
      callBackFn
    );
  },
  async getKhmelnytskyiAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-khmelnytskyi/get-khmelnytskyi-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
